// @flow
export const STUDENT_STATUSES_FILTER_CLEAR: 'reports/STUDENT_STATUSES_FILTER_CLEAR' = 'reports/STUDENT_STATUSES_FILTER_CLEAR';
export const STUDENT_STATUSES_FILTER_DELETE: 'reports/STUDENT_STATUSES_FILTER_DELETE' = 'reports/STUDENT_STATUSES_FILTER_DELETE';
export const STUDENT_STATUSES_FILTER_SET: 'reports/STUDENT_STATUSES_FILTER_SET' = 'reports/STUDENT_STATUSES_FILTER_SET';
export const STUDENT_STATUSES_FILTER_UPDATE: 'reports/STUDENT_STATUSES_FILTER_UPDATE' = 'reports/STUDENT_STATUSES_FILTER_UPDATE';
